import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Portfolio = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Testimonial slider functionality
    const slides = document.querySelectorAll(".slide");
    const thumbnails = document.querySelectorAll(".thumbnail");
    let slideInterval;

    const showSlide = (index) => {
      slides.forEach((slide) => slide.classList.remove("active"));
      thumbnails.forEach((thumbnail) => thumbnail.classList.remove("active"));

      if (slides[index]) slides[index].classList.add("active");
      if (thumbnails[index]) thumbnails[index].classList.add("active");

      setCurrentSlide(index);
    };

    const nextSlide = () => {
      const nextIndex = (currentSlide + 1) % slides.length;
      showSlide(nextIndex);
    };

    const startAutoSlide = () => {
      slideInterval = setInterval(nextSlide, 5000);
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", () => {
        clearInterval(slideInterval);
        showSlide(index);
        startAutoSlide();
      });
    });

    showSlide(0);
    startAutoSlide();

    return () => {
      clearInterval(slideInterval);
    };
  }, [currentSlide]);

  return (
    <div className="portfolio-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.5s">
              Portfolio
            </h1>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Case Studies</span>
          </div>
          <div className="title row">
            <div className="col col-6 wow fadeInUp">
              <h2>
                <span className="gradient-text">Success stories</span> - See how
                we’ve helped our clients
              </h2>
            </div>
            <div className="col col-6 wow fadeInUp">
              <p>
                We help companies and startups to build efficient digital
                products with a human-first approach through proper UX &
                interaction design.
              </p>
              <Link to="/portfolio" className="btn btn-shadow">
                VIEW ALL <span className="arrow"></span>
              </Link>
            </div>
          </div>
          <div className="portfolio card-deck-js wow fadeInUp">
            <div className="portfolio-card">
              <Link to="/the-home-depot">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/depo.svg"
                      alt="The Home Depo"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>The Home Depot</h3>
                      <div>
                        <span>Ui/Ux</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/klokbox">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/klokbox.svg"
                      alt="Klokbox"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Klokbox</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="Arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/deltra">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/deltra.svg"
                      alt="Deltra"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Deltra</h3>
                      <div>
                        <span>Ui/Ux</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="Arrow-4" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-5" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-6" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-7" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonial-section">
        <div className="container wow fadeInUp">
          <div className="title-small wow fadeInUp">
            <span>Testimonial</span>
          </div>
          <div className="title">
            <h2>
              <span className="gradient-text">Empowered Partnerships </span>
              :<br />
              Testimonials that Inspire
            </h2>
          </div>
          <div className="tabs">
            <div className="slider-wrapper">
              <div className="slider mySwiper">
                <div className="slide active">
                  <div className="testimonial-tabs-data">
                    <div className="reviews-video">
                      <a
                        href="https://www.youtube.com/watch?v=bTKUX-WEBt4"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/images/reviews/klokbox/klokbox.png"
                          alt="klokbox"
                        />
                      </a>
                    </div>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/klokbox/user.jpg"
                            alt="klokbox-user"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Daniel Culloty</h4>
                          <h5>CEO, Klokbox</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/danielculloty/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="danielculloty"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <div className="reviews-video">
                      <a
                        href="https://www.youtube.com/watch?v=MWYh9wbWv_g"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="/assets/images/reviews/autobiography/autobio.png"
                          alt="autobiography"
                        />
                      </a>
                    </div>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/autobiography/cliant.png"
                            alt="autobiography"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Arie Botbol</h4>
                          <h5>CEO, Stealth Mode</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/ariebotbol/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="ariebotbol"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      Thanks to team's expertise in Flutter, our food tracker
                      and calorie counter app for the French market has been a
                      tremendous success. We look forward to a long-term
                      partnership for future updates and maintenance.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/ltg/client-ltg.jpg"
                            alt="client-ltg"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Marion Grassia</h4>
                          <h5>CEO , LAISSE-TOI GUIDER</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/marion-grassia-85095322a/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="marion-grassia"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      Slash Star turned my team's concept of a mobile app
                      connecting via Bluetooth and web 3.0 into an astounding
                      reality. Their professionalism, transparent communication,
                      development speed, and technical expertise were evident
                      throughout the project. The end result was a seamlessly
                      designed app that effortlessly integrates Bluetooth
                      connectivity. For anyone seeking a dedicated development
                      partner that transforms ideas into technological
                      brilliance, I wholeheartedly recommend Slash Star.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/nilo/image.png"
                            alt="nilo"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Seung Hwan Lee</h4>
                          <h5>CEO, Nilo.gg</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/seungh-lee/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="seungh-lee"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      We were able to successfully complete the project by
                      meeting the best partner. They have a very good
                      understanding of development and skills, and are fully
                      committed to the task schedule. The time we met and spent
                      with them is lucky for us. We'll always work on the
                      project with them.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/finutzz/user.jpg"
                            alt="finutss-user"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Min Suk Kim</h4>
                          <h5>CEO, Nine Peace Co. Ltd.</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/min-suk-kim-9040311b2/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="min-suk-kim"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slide">
                  <div className="testimonial-tabs-data">
                    <p>
                      The team delivered a super functional product, within an
                      impressive timeframe, that has stood the test of time
                      through the growth of our user base. They have been
                      extremely responsive all throughout.
                    </p>
                    <div className="client-namess">
                      <div className="client flex">
                        <div className="client-img">
                          <img
                            src="/assets/images/reviews/telly/client-telly.jpg"
                            alt="client-Telly"
                          />
                        </div>
                        <div className="client-details">
                          <h4>Karen Zhao</h4>
                          <h5>Co-founder, Telly</h5>
                        </div>
                      </div>
                      <div className="client-social">
                        <a
                          href="https://www.linkedin.com/in/karenzhao2/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="/assets/images/icon/linkedin.svg"
                            alt="karen zhao"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="thumbnails">
              <div className="thumbnail active" data-slide="0">
                <img
                  src="/assets/images/logos/logo-klokbox-1.svg"
                  alt="klokbox Thumb 1"
                />
              </div>
              <div className="thumbnail" data-slide="1">
                <img
                  src="/assets/images/reviews/autobiography/logo.png"
                  alt="autobiography Thumb 2"
                />
              </div>
              <div className="thumbnail" data-slide="2">
                <img
                  src="/assets/images/logos/logo-ltg.svg"
                  alt="logo Thumb 3"
                />
              </div>
              <div className="thumbnail" data-slide="3">
                <img
                  src="/assets/images/logos/nilo-orignal.svg"
                  alt="nilo Thumb 4"
                />
              </div>
              <div className="thumbnail" data-slide="4">
                <img
                  src="/assets/images/logos/logo-finutss-1.svg"
                  alt="finutss Thumb 5"
                />
              </div>
              <div className="thumbnail" data-slide="5">
                <img
                  src="/assets/images/logos/dark-telly.svg"
                  alt="telly Thumb 6"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
